import templateUrl from './payment-methods.html'

export const paymentMethodsComponent = {
    bindings: {
        details: '<'
    },

    templateUrl,

    controller: class PaymentMethodsComponent {
        constructor($state, toastr, CompareObjectService, ModalService, PaymentMethodsService) {
			'ngInject';

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.paymentMethodsService = PaymentMethodsService;
		}

        $onInit() {
            this.paymentMethods = this.paymentMethodsService.getPaymentMethods(this.details);
            this.pageTitle = "Edit Payment Method";

            this.details = {
                paymentMethod: ''
            };
        }

		onPaymentMethodsAdd(){
            this.modalService.open({
				backdrop: 'static',
				keyboard: false,
				component: 'paymentMethodsAdd',
				details: {
                    reloadList: () => {
                        this.$state.reload();
                    } 
                }		
			});
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/payment-methods/payment-methods.component.js